import {Helmet} from "react-helmet-async";
import {Container, Stack, Typography} from "@mui/material";
import React from "react";
import {Outlet} from "react-router-dom";

export default function VotePage() {
    return (
        <>
            <Helmet>
                <title> Vote | Lose Awards </title>
            </Helmet>

            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Votes
                    </Typography>
                </Stack>

                <Container>
                    <Outlet />
                </Container>
            </Container>
        </>
    );
}